module.exports = __webpack_public_path__ + "assets/c808688d50f4adea689cf2e4cb89571b.png";